import setSiteMeta from '../base-saving-actions/set-site-meta';

const createCustomTextColors = (colors) =>
  setSiteMeta(['customization', 'customTextColors'], colors);

export default createCustomTextColors;
